<template>
  <div id="ticketNote">
    
    <div class="vo-card">
      <div class="header-small">Manager Tools</div>
      <div class="details">
        <div class="section">
          <div class="section-title">Ticket Status</div>
          
          <v-radio-group :disabled="statusLockout" :loading="statusLockout" @change="statusChanged" hide-details v-model="ticket.status" :mandatory="true">
            <v-radio color="primary" v-for="(status, key) in $store.getters.company.statuses" :value="key" :key="key">
              <div style="text-transform: capitalize;" slot="label">{{ key }}</div>
            </v-radio>
          </v-radio-group>
        </div>


        <div class="section">
          <div class="section-title">Assignees</div>

          <v-select
            ref="assigneePicker"
            placeholder="Add Assignees"
            @keyup="searchAssignees(assigneePicker.searchText)"
            @change="changeAssignee($event)"
            :disabled="assigneePicker.lockout"
            autocomplete
            :loading="assigneePicker.loading"
            multiple
            chips
            :items="assigneePicker.searchResults"
            item-text="fullName"
            :search-input.sync="assigneePicker.searchText"
            item-value="_id"
            v-model="ticket.assignees">
          
            <template slot="selection" slot-scope="data">
              <div class="vo-user-chip">
                <vo-avatar class="avatar" :user="data.item" :size="24"></vo-avatar>
                <div class="name">{{ data.item.fullName }}</div>
                <v-btn class="btn" fab flat small @click="removeAssignee(data.item, $event)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </template>

          </v-select>

        </div>

        <div class="section">
          <div class="section-title">Ticket Tags</div>
          
          <v-select 
            ref="ticketTagPicker"
            :items="ticketTags" 
            @change="changeTicketTag($event)"
            v-model="ticket.type"
            chips
            multiple
            item-value="_id"
            item-text="title"
            >

            <template slot="selection" slot-scope="data">
              <div class="vo-tag">
                <div class="name">{{ data.item.title }}</div>  
                <v-btn class="tag-btn" fab flat small @click="removeTicketTag(data.item._id, $event)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>          
              </div>    
            </template>

          </v-select>
          
        </div>
      </div>
    </div> <!-- Manager Tools -->

  </div>

</template>

<script>

import liveUpdateMixin from '../mixins/liveUpdateMixin.js'

  export default {
    mixins: [liveUpdateMixin],
    data () {
      return {
        
        ticket: {

        },

        timeouts: {
          assignees: false
        },

        // STATUS CHANGED

        statusLockout: false,

        // ASSIGNEE CHANGED

        assigneePicker: {
          lockout: false,
          loading: false,
          searchText: '',
          searchResults: []
        },

        ticketTagPicker: {
          lockout: false
        }

      }
    },

    props: {
      
      page: {
        
      },

      selected: {

      }

    },

    computed: {
      ticketTags () {
        return _.values(this.$store.getters.ticketTags);
      }
    },

    methods: {

      statusChanged () {
        
        if (this.statusLockout) return;
        this.statusLockout = true;        
        
        var ticket = {
          _id: this.ticket._id,
          status: this.ticket.status  
        };

        this.$store.dispatch('updateTicket', {
          property: this.selected.property,
          ticket: ticket
        })
        .then(data => {
          this.updateTicketList(this.ticket._id);
          Toast.show('Ticket status changed.', 'success');
          this.statusLockout = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.statusLockout = false;
        })
      },

      searchAssignees: _.debounce(function (value) {
    
        this.assigneesLoading = true;

        var assignees = [];
        this.selected.assignees.forEach(assignee => {
          assignees.push(this.$store.getters.user(assignee));
        });

        this.$store.dispatch('loadAssignableUsers', {
          property: this.ticket.property,
          filters: {
            search: value
          }
        })
        .then(data => {
          this.assigneePicker.searchResults = [...data, ...assignees].sort(this.sortAssignees);
          this.assigneePicker.loading = false;
        })
        .catch(e => {
          this.assigneePicker.searchResults = [...assignees].sort(this.sortAssignees);
          this.assigneePicker.loading = false;
        });

      }, 200),

      changeAssignee (e) {
        if (this.assigneePicker.lockout) return;

        // Someone was added
        if (e.length > this.selected.assignees.length) {
          var added = e.filter(x => !this.selected.assignees.includes(x));
          this.addAssignee(added[0]);
        }

        // Someone was removed
        else if (e.length < this.selected.assignees.length) {
          var removed = this.selected.assignees.filter(x => !e.includes(x));
          this.removeAssignee(this.$store.getters.user(removed[0]));
        }

      },

      addAssignee (user) {
        if (this.assigneePicker.lockout) return;
        this.assigneePicker.lockout = true;

        this.$store.dispatch('addTicketAssignee', {
          property: this.selected.property,
          ticket: {
            _id: this.selected._id,
            assignees: [user]
          }
        })
        .then(data => {          
          Toast.show('Assignee added.', 'success');
          this.$refs.assigneePicker.blur();
          this.assigneePicker.lockout = false;
        })
        .catch(e => {
          this.assigneePicker.lockout = false;
          Toast.showError(e);
          console.log(e);
        })
      },

      removeAssignee (user, e) {
        if (e) e.stopPropagation();
        if (this.assigneePicker.lockout) return;
        this.assigneePicker.lockout = true;

        this.$store.dispatch('removeTicketAssignee', {
          property: this.selected.property,
          ticket: {
            _id: this.selected._id,
            assignees: [user._id]
          }
        })
        .then(data => {
          var index = this.ticket.assignees.indexOf(user._id);
          if (index >= 0) {
            this.ticket.assignees.splice(index, 1);
          } 
          
          this.$refs.assigneePicker.blur();
          Toast.show('Assignee removed.', 'success');
          this.assigneePicker.lockout = false;
        })
        .catch(e => {
          this.assigneePicker.lockout = false;
          Toast.showError(e);
          console.log(e);          
        })
      },

      changeTicketTag (e) {
        if (this.ticketTagPicker.lockout) return;

        // Someone was added
        if (e.length > this.selected.type.length) {
          var added = e.filter(x => !this.selected.type.includes(x));
          this.addTicketTag(added[0]);
        }

        // Someone was removed
        else if (e.length < this.selected.type.length) {
          var removed = this.selected.type.filter(x => !e.includes(x));
          this.removeTicketTag(removed[0]);
        }

      },

      addTicketTag (ticketTag) {
        if (this.ticketTagPicker.lockout) return;
        this.ticketTagPicker.lockout = true;

        this.$store.dispatch('ticketUpdateTags', {
          ticket: this.selected._id,
          ticketTag: ticketTag,
          property: this.selected.property,
          action: 'add'
        })
        .then(data => {          
          Toast.show('Ticket Tag added.', 'success');
          this.$refs.ticketTagPicker.blur();
          this.ticketTagPicker.lockout = false;
        })
        .catch(e => {
          this.ticketTagPicker.lockout = false;
          Toast.showError(e);
          console.log(e);
        })
      },

      removeTicketTag (ticketTag, e) {
        if (e) e.stopPropagation();
        if (this.ticketTagPicker.lockout) return;
        this.ticketTagPicker.lockout = true;

        this.$store.dispatch('ticketUpdateTags', {
          ticket: this.selected._id,
          ticketTag: ticketTag,
          property: this.selected.property,
          action: 'remove'
        })
        .then(data => {
          var index = this.ticket.type.indexOf(ticketTag);
          if (index >= 0) {
            this.ticket.type.splice(index, 1);
          } 
          
          this.$refs.ticketTagPicker.blur();
          Toast.show('Ticket Tag removed.', 'success');
          this.ticketTagPicker.lockout = false;
        })
        .catch(e => {
          this.ticketTagPicker.lockout = false;
          Toast.showError(e);
          console.log(e);          
        })
      },

      sortAssignees(a, b) {
        return a.lastName.toUpperCase() < b.lastName.toUpperCase() ? -1 : 1;
      },

      selectedChanged () {

        // Initialize assignees
        var assignees = [];
        this.selected.assignees.forEach(assignee => {
          assignees.push(this.$store.getters.user(assignee));
        });

        // Load default assignable users

        if (this.timeouts.assignees) clearTimeout(this.timeouts.assignees);
        this.timeouts.assignees = setTimeout (() => {
          this.assigneePicker.lockout = true;
          this.$store.dispatch('loadAssignableUsers', {
            property: this.selected.property,
            filters: {
              search: ''
            }
          })
          .then(data => {
            Vue.set(this.assigneePicker, 'searchResults', [...assignees, ...data].sort(this.sortAssignees));          
            this.assigneePicker.lockout = false;
          })
          .catch(e => {
            console.log(e);
            this.assigneePicker.lockout = false;
            Toast.showError(e);
          });

          this.ticket = {
            ...this.selected
          };
        }, window.cordova ? 600 : 1); 

      }

    },

    created () {

      this.selectedChanged();

      // Ticket Updated - Here we handle assignee changes
      document.addEventListener('ticketUpdated', (e) => {
        var update = e.detail;

        // Ignore if not selected
        if (this.ticket._id !== update.data._id) return;
        
        // OPTIMIZE: Use more LiveUpdate data rather than fetching everything again
        
        // Wait 1 cycle to allow Selected to update
        this.$nextTick(() => {
          this.selectedChanged();
        });

      });
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketNote {
    
    .vo-card {

      .header {
        position: relative;
        height: 81px;
        width: 100%;
        border-bottom: 1px solid $black12;
      }

      .header-small {
        padding: 16px;
        box-sizing: border-box;
        border-bottom: $borderBlack12;
        @include fontPrimary400;
        @include title();
        font-size: 18px;
      }  

      .details {
        padding: 16px;
        box-sizing: border-box;

        .section {
          margin: 0 0 24px;

          .section-title {
            @include fontPrimary500();
    
            text-transform: uppercase;
            color: $black54;
            font-size: 14px;
            letter-spacing: .5px;
            padding: 16px 0 5px;
            border-bottom: 1px solid $black12;
          }
        }
      }     
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/TicketManageTools.vue